import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { logoutUser } from "../../features/Auth/authSlice";
import { getDev } from "../../features/Dev/devSlice";
import { Container, Grid, Box, Tab } from "@mui/material";
import { TabContext, TabList, TabPanel } from "@mui/lab";

import {
  Code,
  Home,
  Image,
  Image as ImageIcon,
  LinkedIn,
  Work,
} from "@mui/icons-material";
import { Routes, Route } from "react-router-dom";

import MenuList from "./MenuList";
import Dashboard from "./Dashboard";
import UserInfo from "./UserInfo";
import Projects from "./Projects";
import Skill from "./Skill";
import ChangePassword from "./ChangePassword";
import Socials from "./Socials";
import DevInfo from "./DevInfo";
// import Skills from "../Devs/Skills";

const Profile = () => {
  const { dev } = useSelector((state) => state.dev);
  const { lastName, name, email, phone, photo_url, id } = dev;
  const [tab, setTab] = useState("1");

  const route = window.location.href;

  const dispatch = useDispatch();

  const handleTab = (event, value) => {
    setTab(value);
  };

  useEffect(() => {
    dispatch(getDev());
  }, []);

  // if (!cookie) {
  //   dispatch(logoutUser());
  // }

  // useEffect(() => {
  //   const cookie = document.cookie;
  //   console.log(cookie);
  //   if (!cookie) {
  //     dispatch(logoutUser());
  //   }
  // }, []);

  return (
    <>
      <Box
        pt={3}
        sx={{
          // height: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Grid container spacing={1}>
          <Grid item xs={12} sm={12} md={3}>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                height: { md: "80vh", sm: "absolute" },
              }}
            >
              <Container maxWidth="md">
                <Dashboard />
              </Container>
            </Box>
          </Grid>
          <Grid item xs={12} sm={12} md={9}>
            <Box>
              <Container maxWidth="md">
                <TabContext value={tab}>
                  <Box sx={{ width: "100%" }}>
                    <TabList
                      onChange={handleTab}
                      // variant="scrollable"
                      // scrollButtons="auto"
                      centered
                    >
                      <Tab label="Home Page" value="1" icon={<Home />} />
                      <Tab label="Skills" value="2" icon={<Code />} />
                      <Tab label="Works" value="3" icon={<Work />} />
                      <Tab label="Socials" value="4" icon={<LinkedIn />} />
                    </TabList>
                  </Box>
                  <TabPanel value="1">
                    <DevInfo />
                  </TabPanel>
                  <TabPanel value="2">
                    <Skill />
                  </TabPanel>
                  <TabPanel value="3">
                    <Projects />
                  </TabPanel>
                  <TabPanel value="4">
                    <Socials />
                  </TabPanel>
                </TabContext>
              </Container>
            </Box>
          </Grid>
        </Grid>
      </Box>
    </>
  );
};

export default Profile;
// {
//   route === `http://localhost:3000/dev/dashboard` && <Contact />;
// }
// {
//   route === `http://localhost:3000/dev/skills` && <Skill />;
// }
// {
//   route === `http://localhost:3000/dev/projects` && <Projects />;
// }
